import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@mui
import { Box, Chip, Paper, Typography } from '@mui/material';
//components
import CostSummary from '../../../components/projectmng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/projectmng/costcalc/CostCalcLockList';
import { useEffect } from 'react';
import { listProjectCosts } from '../../../modules/projectModule/projectCosts';

// 확정된 원가 산출 내역 섹션(프로젝트 쪽) - 검은 제목바(DetailTemplate) 대신 흰 카드 + 얇은
// 테두리로 편집 표(CostCalcListForm)와 톤을 맞췄다(옵션 B, chancemng와 동일 패턴).
const CostCalcLockContainer = () => {
  const dispatch = useDispatch();
  const { project, costs } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    costs: projectModule.projectCosts.costs,
  }));

  useEffect(() => {
    if (project) {
      dispatch(listProjectCosts(project.prjUuid));
    }
  }, [project]);

  return (
    <Paper variant="outlined" sx={{ borderRadius: 1.5, overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          px: 2,
          py: 1.25,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="subtitle1" fontWeight={700} component="div">
            원가 산출
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {costs?.length || 0}개 품목
          </Typography>
        </Box>
        <Chip size="small" color="success" variant="outlined" label="확정됨" />
      </Box>
      <Box sx={{ px: 2, pt: 1 }}>
        <CostSummary project={project} />
      </Box>
      <Box sx={{ p: costs && costs.length > 0 ? 0 : 2 }}>
        {costs && costs.length > 0 ? (
          <CostCalcLockList costs={costs} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            원가산출 내역이 없습니다.
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default CostCalcLockContainer;
